module.exports = __webpack_public_path__ + "static/media/logo-footer.6bef4fb4.png";